<template>
  <div>
    <div class="div-img-top2 body-width divcss5 join_font">
      <div class="font_zh">
        {{$t("join.joinus")}}
      </div>
      <div class="font_en font_en_top">
        JOIN US
      </div>
    </div>
    <div class="row" style="margin-left: 8px">
      <div class="border_right_line">
        <div class="single_body_right">
          <div class="join_header">
            <a @click="setroters('/join/intern')">
              <img src="../../../assets/images/joinus/joinus_intern.png">
            </a>
          </div>
          <div class="join_title">
            {{$t("join.intern")}}
          </div>
          <div class="join_summary">
            <P>
              {{$t("join.positiondescribe")}}<br>
              1、辅助工程师基于unity3D引擎进行开发，
              实现相关功能编码，测试，发布<br>
              2、辅助工程师对接美术资源（3D模型等）
              ,调整特效<br>
              3、其他项目中涉及到的VR技术的研发支持
            </P>
          </div>
      
            <div @mouseenter="enter('isflag')" @mouseleave="leave('isflag')" :class="header.isflag==true?'job_return1':'job_return2'"><a @click="setroters('/join/intern')" >{{$t("join.detail")}}</a></div>
     
        </div>
      </div>
      <div >
      <div class="single_body_left single_body_right">
        <div class="join_header">
          <a @click="setroters('/join/programmer')"><img src="../../../assets/images/joinus/joinus_programmer.png"></a>
        </div>
        <div class="join_title">
          {{$t("join.programmer")}}
        </div>
        <div class="join_summary">
          <P>
            {{$t("join.positiondescribe")}}<br>
            1、基于Unity引擎，制作实现VR虚拟显示产品中的交互功能<br>
            2、负责程序架构的搭建<br>
            3、负责项目的系统逻辑、用户界面，以及图形特效的程序开发
          </P>
        </div>
     
        <div @mouseenter="enter('isflag1')" @mouseleave="leave('isflag1')" :class="header.isflag1==true?'job_return1':'job_return2'">  <a @click="setroters('/join/programmer')">{{$t("join.detail")}}</a></div>
   
      </div>
      </div>
      <div class="border_left_line">
        <div class="single_body_left single_body_right">
          <div class="join_header">
            <a @click="setroters('/join/modeler')"><img src="../../../assets/images/joinus/joinus_modeler.png"></a>
          </div>
          <div class="join_title">
            {{$t("join.modeler")}}
          </div>
          <div class="join_summary">
            <P>
              {{$t("join.positiondescribe")}}<br>
              1、精通3DMax精模、简模制作，熟练使用
              PS、AutoCAD等软件<br>
              2、熟悉3D场景制作流程及规范，精通3D场
              景模型以及材质贴图的制作，能熟练并独
              立完成效果图的渲染以及后期贴图；对效
              果图空间感、材料质感、灯光渲染等有较
              强的表现能力<br>
            </P>
          </div>
     
          <div @mouseenter="enter('isflag2')" @mouseleave="leave('isflag2')" :class="header.isflag2==true?'job_return1':'job_return2'">  <a @click="setroters('/join/modeler')">{{$t("join.detail")}}</a></div>
      
        </div>
      </div>
      <div class="border_left_line">
        <div class="single_body_right single_body_left">
          <div class="join_header">
            <a @click="setroters('/join/engineer')"><img src="../../../assets/images/joinus/joinus_engineer.png"></a>
          </div>
          <div class="join_title">
            {{$t("join.engineer")}}<br>
          </div>
          <div class="join_summary">
            <p>
              {{$t("join.positiondescribe")}}<br>
              1、熟悉C/C++开发语言，精通Windows下
              程序开发<br>
              2、根据项目计划，保质保量按时完成开发
              任务<br>
              3、编写模块核心代码，解决产品开发中的
              问题<br>
              4、负责相关产品模块的功能设计，负责产
              品文档的撰写
            </p>
          </div>
       
           <div @mouseenter="enter('isflag3')" @mouseleave="leave('isflag3')"   :class="header.isflag3?'job_return1':'job_return2'"> <a @click="setroters('/join/engineer')">{{$t("join.detail")}}</a></div>
      
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex'
  export default {
    name: "joinpartcontent",
    data() {
      return {
        header:{
          showindex:false,
          showabout:false,
          showproduct:false,
          shownews:false,
          showjoin:true,
          showpartner:false,
          showcontact:false,
          showlanguage:false,
          isflag:false,
          isflag1:false,
          isflag2:false,
          isflag3:false
        }
      }
    },
    methods: {
      ...mapMutations(['setHeaderTitle']),
      setroters(src) {
        this.switchStyle()
        this.$router.push(src);
      },
      switchStyle(){
        this.setHeaderTitle(this.header)
      },
      enter (src) {
        if('isflag'===src){
       this.header.isflag = true;
        }else if(src==='isflag1'){
       this.header.isflag1 = true;
        }else if(src==='isflag2'){
       this.header.isflag2 = true;
        }else if(src==='isflag3'){
       this.header.isflag3 = true;
        }
 
      },
      leave (src) {
              if('isflag'===src){
  this.header.isflag = false;
        }else if(src==='isflag1'){
  this.header.isflag1 = false;
        }else if(src==='isflag2'){
  this.header.isflag2 = false;
        }else if(src==='isflag3'){
  this.header.isflag3 = false;
        }
      
      }
    }
  }
</script>

<style scoped>
  /*字体*/
  .font_zh{
    font-size: 24px;
    color: #0D3E88;
  }
  .font_en{
    font-size: 16px;
    color: #2E79BE;
  }
  .border_right_line{
    background-image: url(../../../assets/images/joinus/joinus_line.png)   ;
    background-position:right 0;
    background-repeat: no-repeat ;
  }
  .border_left_line{
    background-image: url(../../../assets/images/joinus/joinus_line.png)   ;
    background-position:left 0;
    background-repeat: no-repeat ;
  }
  /*join us --- start*/
  .join_font{
    margin-bottom: 40px;
  }
  .join_header{
    padding-bottom: 20px;
  }
  .join_title{
    font-size: 18px;
    color: #333333;
    padding-bottom: 18px;
  }
  .join_summary{
    text-align: left;
    width: 272px;
    height: 200px;
  }
  .join_summary p{
    font-size: 14px;
    color: #B6B6B6;
    line-height: 21px;
  }

  .single_body_right{
    padding-right: 7px;
  }
  .single_body_left{
    padding-left: 7px;
  }
  /*join us --- end*/

  .job_return1 {
     font-size: 14px;
  color: #2E79BE;
}
  .job_return2 {
     font-size: 14px;
  color: #666666;;
}
.row{
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/indexcontentcoms/joinpartcontent.vue